export class ContentNextGenHeader {
  headerIcon: string;
  headerlabel: string;
  id: string;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['headerIcon']) {
        this.headerIcon = contentjson['headerIcon'];
      }
      if (contentjson['headerlabel']) {
        this.headerlabel = contentjson['headerlabel'];
      }
      if (contentjson['id']) {
        this.id = contentjson['id'];
      }
    }
  }
}
